<template>
  <v-card flat class="mx-auto pb-0 mb-0">
    <v-card-text class="pb-0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field
            v-model="form.termo"
            outlined
            label="Termo"
            append-icon="mdi-magnify"
            dense
            @keydown.enter="buscar"
          ></v-text-field>
        </v-col>
        <!-- <v-col>
          <v-btn tile color="primary" class="mr-2" @click="form.termo = form.termo + ' |e| '">e</v-btn>
          <v-btn tile color="primary" class="mr-2" @click="form.termo = form.termo + ' |ou| '">ou</v-btn>
          <v-btn tile color="primary" class="mr-2" @click="form.termo = form.termo + ' |adj| '">adj</v-btn>
          <v-btn tile color="primary" class="mr-2" @click="form.termo = form.termo + ' |nao| '">não</v-btn>
          <v-btn tile color="primary" @click="form.termo = form.termo + ' |prox| '">prox.</v-btn>
        </v-col> -->
        <v-col :cols="isMobile ? 12 : 2" class="mr-2">
          <v-text-field
            v-model="form.ano"
            outlined
            label="Ano"
            dense
            v-mask="'####'"
            @keydown.enter="buscar"
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : ''" class="mr-2">
          <v-select
            v-model="form.relevancia"
            outlined
            label="Relevância"
            :items="relevancias"
            item-text="text"
            item-value="key"
            dense
          ></v-select>
        </v-col>
        <v-col :cols="isMobile ? '' : 'auto'">
          <v-btn block color="primary" @click="buscar">
            <v-icon class="mr-2">mdi-magnify</v-icon>
            buscar
          </v-btn>
        </v-col>
        <v-col :cols="isMobile ? '' : 'auto'">
          <v-btn block color="orange" dark @click="limpar" class="mx-1">
            limpar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: { filtrosFormulario: {}, isMobile: { type: Boolean, default: false } },
  data() {
    return {
      form: {
        relevancia: ""
      },
      relevancias: [
        { key: "", text: "MAIS RELEVANTES" },
        { key: "&sort=sessao_data&order=asc", text: "MAIS ANTIGOS" },
        { key: "&sort=sessao_data&order=desc", text: "MAIS RECENTES" }
      ]
    };
  },
  mounted() {
    this.form = this.filtrosFormulario;
  },
  watch: {
    filtrosFormulario: {
      handler() {
        this.form = this.filtrosFormulario;
      }
    }
  },
  methods: {
    buscar() {
      this.form.hash = "";
      this.form.historico = false;
      this.form.selected = 0;
      this.form.isMobile = this.isMobile;
      this.$emit("search", this.form);
    },
    limpar() {
      this.form = {};
    }
  }
};
</script>
